import { createContextScope } from '../../internal/context/scoped-context';
import { DIALOG_NAME, PORTAL_NAME } from './constants';
export const [createDialogContext, createDialogScope] = createContextScope(DIALOG_NAME);
export const [DialogProvider, useDialogContext] = createDialogContext(DIALOG_NAME);
export const [PortalProvider, usePortalContext] = createDialogContext(PORTAL_NAME, {
  forceMount: undefined
});